import React, { useState } from 'react';
import {
  ErrorMessage, Field, Form, Formik,
} from 'formik';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import SectionsInfo from '../SectionsInfo';
import ValidationSchema from '../../helpers/ValidationSchema';
import sendIcon from '../../assets/icons/send.svg';
import removeHtmlTags from '../../helpers/removeHtmlTags';
import { sendFiatBackRequest } from '../../store/actions/sendFiatBack';
import Spinner from '../Spinner';

function Question({ data }) {
  const [method, setMethod] = useState('question');

  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const [sending, setSending] = useState(false);
  const { reviewSchema, questionSchema } = ValidationSchema();
  const { translations } = useSelector((state) => state.translation);
  const { t } = useTranslation();
  const handleSend = async (formData) => {
    setSending(true);
    const dataForSend = {
      full_name: formData.fullName,
      email: formData.email,
      message: formData[method],
      lang,
    };
    const { payload } = await dispatch(sendFiatBackRequest({ dataForSend, method }));
    if (payload.success) {
      toast(translations.review_sent_successfully[lang]);
    }
    setSending(false);
  };
  return (
    <div className="question">
      <div className="container small">
        <div className="question__content">
          <img
            src={data.image.webp_url}
            alt={data.image.alt_attribute[lang] || removeHtmlTags(data.two_blog_title[lang])}
          />
          <div className="question__main">
            <div className="question__circle" />
            <SectionsInfo
              isSlider={false}
              isPartner={false}
              title={removeHtmlTags(data.two_blog_title[lang])}
              description={removeHtmlTags(data.two_blog_description[lang])}
            />
            <div className="question__content-selector">
              <div className="question__content-selector-content">
                <button onClick={() => setMethod('review')} className={`question__content-selector-btn ${method === 'review' ? 'active' : ''}`} type="button">{translations.your_review[lang]}</button>
                <button onClick={() => setMethod('question')} className={`question__content-selector-btn ${method === 'question' ? 'active' : ''}`} type="button">{translations.ask_a_question[lang]}</button>
              </div>
            </div>
            <Formik
              key={method}
              initialValues={method !== 'question' ? {
                email: '',
                fullName: '',
                review: '',
              } : {
                email: '',
                fullName: '',
                question: '',
              }}
              onSubmit={async (values, actions) => {
                actions.setSubmitting(false);
                await handleSend(values);
                actions.resetForm();
              }}
              validationSchema={method === 'question' ? questionSchema : reviewSchema}
            >
              <Form className="register-form">
                <div className="question__inputs-row">
                  <div className="register-form-group">
                    <label className="inputs-label" htmlFor="fullNameQestion">{translations.full_name_label[lang]}</label>
                    <div className="register-form-group_input input-block">
                      <Field
                        as="input"
                        type="text"
                        name="fullName"
                        id="fullNameQestion"
                        placeholder={translations.full_name_placeholder[lang]}
                      />
                    </div>
                    <ErrorMessage
                      name="fullName"
                      component="p"
                      className="authError"
                    />
                  </div>
                  <div className="register-form-group">
                    <label className="inputs-label" htmlFor="emailQuestion">{translations.email_label[lang]}</label>
                    <div className="register-form-group_input input-block">
                      <Field
                        as="input"
                        type="text"
                        name="email"
                        id="emailQuestion"
                        placeholder={translations.email_placeholder[lang]}
                      />
                    </div>
                    <ErrorMessage
                      name="email"
                      component="p"
                      className="authError"
                    />
                  </div>
                  <div className="register-form-group big">
                    <label className="inputs-label" htmlFor={method === 'question' ? 'question' : 'review'}>
                      {method === 'question' ? t('question') : t('review')}
                    </label>
                    <div className="register-form-group_input input-block">
                      <Field
                        as="textarea"
                        type="text"
                        name={method === 'question' ? 'question' : 'review'}
                        id={method === 'question' ? 'question' : 'review'}
                        placeholder={method === 'question' ? t('placeholder.question') : t('placeholder.review')}
                      />
                    </div>
                    <ErrorMessage
                      name={method === 'question' ? 'question' : 'review'}
                      component="p"
                      className="authError"
                    />
                  </div>
                </div>
                <button type="submit" className="question__form-btn">
                  {sending ? <Spinner isBtn width={30} height={30} size={30} /> : (
                    <>
                      <img src={sendIcon} alt="send request" />
                      {}
                      <p>{translations.send[lang]}</p>
                    </>
                  )}
                </button>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Question;
